var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"showAside pull-left",on:{"click":_vm.toggleClick}},[_c('i',{staticClass:"el-icon-menu"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }